import { Component, Inject, OnInit } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogActions,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MyLog } from '@common/common';
import { DocumentUploadEvent } from '@data/data.module.types';
import { DataService } from '@data/data.service';
import { NotificationService } from '@notification/notification.service';
import { isJsObject } from '@util/utils';
import {
  DocumentUploadParams,
  DocumentUploadResult,
  OrderDataHandler,
} from '../order-data-handler';
import { CommonModule } from '@angular/common';
import { InputModule } from '@input/input.module';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { DataModule } from '@data/data.module';

@Component({
  selector: 'app-file-upload-dialog',
  standalone: true,
  imports: [
    CommonModule,
    DataModule,
    InputModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDialogContent,
    MatDialogActions,
    MatDialogTitle,
  ],
  templateUrl: './file-upload-dialog.component.html',
})
export class FileUploadDialogComponent implements OnInit {
  fileName = '';

  selectedFile = '';

  selectedType: any;

  file?: File;

  imageResolutions: any = [];
  imageResId: any;
  imageTypes: any = [];
  imageTypeId: any;

  types: any[] = [
    {
      id: 100,
      name: 'Unbekannt',
    },
  ];

  constructor(
    public dialogRef: MatDialogRef<FileUploadDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private dataService: DataService,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    if (Array.isArray(this.dialogData.doctypes)) {
      this.types = this.dialogData.doctypes;
    }

    this.selectedType = this.types[0];

    this.setupScaleParameters(this.dialogData);
  }

  onFileSelected($event: any) {
    this.file = $event?.target?.files[0];
    if (this.file) {
      this.selectedFile = this.file.name;
    }
  }

  close() {
    this.dialogRef.close(null);
  }

  isUploading = false;

  progressData: any;

  save() {
    const service = OrderDataHandler.create(this.dataService);

    const callback = ($event: DocumentUploadEvent) => {
      if ($event && $event.type === 'IN_PROGRESS') {
        this.progressData = {
          loaded: $event.loaded,
          total: $event.total,
        };
      }
    };

    this.isUploading = true;

    const params: DocumentUploadParams = {
      type: 'doc',
      orderId: this.dialogData.orderId,
      file: this.file,
      fileName: this.fileName,
      doctype: this.selectedType?.id,
      progressCallback: callback,
      convert: this.convert,
    };

    service.uploadDocument(params).then((res: DocumentUploadResult) => {
      this.isUploading = false;

      if (res.success) {
        res.msg && this.notificationService.showSuccess(res.msg);

        this.dialogRef.close({
          id: res.id,
        });
      } else {
        res.errors && this.notificationService.showErrors(res.errors);
      }
    });
  }

  setupScaleParameters(dialogData: any) {
    if (isJsObject(dialogData?.convert)) {
      const o = dialogData?.convert;
      MyLog.log('Convert config:', o);
      this.imageResolutions = o.imageResolutions;
      this.imageTypes = o.imageTypes;
      this.imageResId = o.imageResId;
      this.imageTypeId = o.imageTypeId;
      this.setupSelectedOutputResolution();
      this.setupSelectedOutputType();
    }
  }
  setupSelectedOutputResolution() {
    if (Array.isArray(this.imageResolutions)) {
      this.convert.resolution = this.imageResolutions.find((e: any) => {
        return e && e.id === this.imageResId;
      });
    }
  }

  setupSelectedOutputType() {
    if (Array.isArray(this.imageTypes)) {
      this.convert.type = this.imageTypes.find((e: any) => {
        return e && e.id === this.imageTypeId;
      });
    }
  }

  convert: any = {};

  onResChange($event: any) {
    this.convert.resolution = $event;
  }

  onTypeChange($event: any) {
    this.convert.type = $event;
  }
}
